import React, {useState} from "react";
import MyImage from './Images/men1.jpg'
// import Typing from "./Typing";
import { Typewriter } from "typewriter-effect";
import Typical from 'react-typical'
import Particle from "./Particle";
import { Link } from "react-router-dom";
import CV from "./docs/cv.docx"



const Welcome = () => {

    return (
        <>
            <Particle />
            <div className="wrap">
                <div className="no-respons">
                    <div className="wrap-left">
                        <h1 className="wrap-h1">Hi, There</h1>
                        <h2 className="wrap-h2">I'm, <span className="name">Istam Rustamov</span></h2>
                    
                        {/* <Typing /> */}
                        <div className="type-text">
                            <p className="typing-text-default">
                                I'm {' '} 
                                    <Typical className="typing-text"
                                        steps={[
                                            'Frontend Developer',
                                            1000,
                                            'JavaScript Developer',
                                            1000,
                                            'React Developer',
                                            1000,
                                        ]}
                                        wrapper="p"
                                        loop={Infinity}
                                        
                                    />
                                
                            </p>
                        
                        </div>

                        <a download href={CV} className="resume-down">
                            Download Resume 
                            <span><i class="fa-regular fa-file-pdf"></i></span>
                        </a>
                        <Link to="/aboutme" className="lets-go-btn res-mobile ">About me</Link>

                    </div>
                        <div className="wrap-right">
                            <div className="image">
                                <img className="myImage" src={MyImage} alt="my image" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mobile-respons">
                    <div className="wrap-right">
                        <div className="image">
                            <img className="myImage" src={MyImage} alt="my image" />
                        </div>
                    </div>
                    <div className="wrap-left">
                        <h1 className="wrap-h1">Hi, There</h1>
                        <h2 className="wrap-h2">I'm, <span className="name">Istam Rustamov</span></h2>
                        
                        {/* <Typing /> */}
                        <div className="type-text">
                            <p className="typing-text-default">
                                I'm {' '} 
                                    <Typical className="typing-text"
                                        steps={[
                                            'Frontend Developer',
                                            1000,
                                            'JavaScript Developer',
                                            1000,
                                            'React Developer',
                                            1000,
                                        ]}
                                        wrapper="p"
                                        loop={Infinity}
                                        
                                    />
                                
                            </p>
                        </div>

                        <a download href={CV} className="resume-down mobile-resume-down">
                            Download Resume 
                            <span><i class="fa-regular fa-file-pdf"></i></span>
                        </a>
                        <Link to="/aboutme" className="lets-go-btn res-mobile ">About me</Link>

                    </div>
                </div>
                
            <Link to="/aboutme" className="lets-go-btn res-no-btn">About me</Link>
            
        </>
    );
}


export default Welcome;